module.exports = __webpack_public_path__ + "static/tradee_about2-bf7e7b7320013aefb732622441f22137.png";